import apiRequest from './index'

export default {
  path: '/v1/carwash_coupon/__DTYPE__/__SSCODE__',

  async get (ssCode, popinfoid, tsid, otoken, dtype) {
    await window.callNativeHTTPX()
    return apiRequest.get(this.path.replace(/__SSCODE__/g, ssCode).replace(/__DTYPE__/g, dtype), {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
        'APP-USERS-POPINFO-ID': popinfoid,
        'APP-USERS-INTEC-TSID': tsid,
        'APP-USERS-INTEC-OTOKEN': otoken
      }
    })
  }
}
